"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.occupancyDescription = void 0;
const occupancyDescription = (occupancy) => {
    const descriptions = [
        "Single occupancy",
        "Double occupancy",
        "Triple occupancy",
        "Quadruple occupancy",
    ];
    return descriptions[occupancy - 1] || `${occupancy}-Person Occupancy`;
};
exports.occupancyDescription = occupancyDescription;
